module.exports = __webpack_public_path__ + "img/em-rubicon-01.40ee078a.webp";